<template>
  <div class="property-list-page app-content">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.property.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Create -->
    <div class="app-content-create">
      
      <!-- Filter button -->
      <app-filter-button :active.sync="activeFilter" />

      <!-- Create -->
      <router-link 
        v-if="hasPermissionToCreate" 
        :to="{ path: '/property/new' }"
      >
        <el-button class="app-content-create-button" type="primary">
          <app-i18n code="entities.property.new.button" />
        </el-button>
      </router-link>
    </div>

    <!-- Filter form -->
    <app-property-list-filter v-if="activeFilter" />

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.property.list.title"></app-i18n>
      </h1>

      <app-property-list-toolbar></app-property-list-toolbar>
      <app-property-list-table></app-property-list-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { PropertyPermissions } from '@modules/property/property-permissions';
import PropertyListFilter from '@modules/property/components/property-list-filter.vue';
import PropertyListTable from '@modules/property/components/property-list-table.vue';
import PropertyListToolbar from '@modules/property/components/property-list-toolbar.vue';

export default {
  name: 'app-property-list-page',
  data() {
    return {
      activeFilter: false,
    };
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),
    hasPermissionToCreate() {
      return new PropertyPermissions(this.currentUser)
        .create;
    },
  },
  
  components: {
    [PropertyListFilter.name]: PropertyListFilter,
    [PropertyListTable.name]: PropertyListTable,
    [PropertyListToolbar.name]: PropertyListToolbar,
  },
};
</script>
